import config from 'config';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import "LIBRARY/Components/ResourceStatus/ResourceStatus.css";
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import InformationModal from 'LIBRARY/CommonResources/InformationModal/InformationModal';
import LibraryApiCall from 'LibraryApiCall';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import { connect } from 'react-redux';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

const apiPath = "/api/library/libraryResourceStatus.php";

const ResourceStatus = (props) => {

    //required states 
    const [statusList, setStatusList] = useState({});
    const [selectedStatusIds, setSelectedStatusIds] = useState([]);
    const [sortedIdArray, setSortedIdArray] = useState([]);
    const [uniqueIdArray, setUniqueIdArray] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [loadingAddOperation, setLoadingAddOperation] = useState(false);
    const [loadingUpdateOperation, setLoadingUpdateOperation] = useState(false);
    const [loadingDeleteOperation, setLoadingDeleteOperation] = useState(false);
    const [pageIndex, setPageIndex] = useState(1);
    // const [addResponse, setAddResponse] = useState([]);
    const [successModal, setSuccessModal] = useState(false);
    const [addStatusData, setAddStatusData] = useState(true);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [successModalType, setSuccessModalType] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [insertedStatus, setInsertedStatus] = useState('');
    const [selectedAccess, setSelectedAccess] = useState('yes');
    const [updatedAccess, setUpdatedAccess] = useState('');
    const [isEditable, setIsEditable] = useState(null);
    const [uniqueId, setUniqueId] = useState(0);
    // const [idToDelete, setIdToDelete] = useState(0);
    const [defaultInputValue, setDefaultInputValue] = useState('');
    const [updatedStatus, setUpdatedStatus] = useState('');
    const [existingAccess, setExistingAccess] = useState('');
    const [selectedRowNumber, setSelectedRowNumber] = useState(0);
    const [hoverId, setHoverId] = useState(0);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedStatusId, setSelectedStatusId] = useState([]);

    const [showActivitySlider, setShowActivitySlider] = useState([]);
    const [selectedIid, setSelectedIid] = useState([]);
    const [hoverID, setHoverID] = useState([]);

    useEffect(() => apiCallToGetStatusList(), []);
    useEffect(() => { setUpdatedStatus(defaultInputValue); setUpdatedAccess(existingAccess); }, [defaultInputValue, existingAccess]);

    const apiCallToGetStatusList = async (pageNumber) => {
        setLoadingStatus(true);

        let requestData = {
            "iid": config.institute_id,
            // "pageIndex": pageNumber != undefined ? pageNumber : pageIndex,
            // "limitPerPage": limit
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryResourceStatus',
            requestData,
            apiPath
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetStatusList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                Object.values(apiResult).map((status) => {
                    status["onHover"] = false;
                })
                setSortedIdArray(jsonResponse.APIResult.sortedIdArray)
                setStatusList(apiResult);
                setLoadingStatus(false);
                setTotalRecords(jsonResponse.APIResult.totalRecords);
            } else {
                setLoadingStatus(false);
                setSuccessModal(true);
                setSuccessModalType('error');
                setSuccessMessage('Something went wrong while getting status data. Please try again later.');
            }
        }
    }

    const apiCallToAddStatus = async () => {
        setLoadingAddOperation(true);

        let requestData = {
            "iid": config.institute_id,
            "status": insertedStatus,
            "facultyId": config.faculty_id,
            "isIssueAccess": selectedAccess
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'addLibraryResourceStatus',
            requestData,
            apiPath
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToAddStatus();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult
                if (apiResult.status == "success") {
                    let insertId = jsonResponse.APIResult.insertedId;
                    let currentDate = jsonResponse.APIResult.currentDate;
                    let statusListCopy = statusList;
                    let sortedIdArrayCopy = sortedIdArray;
                    let totalRecordsCopy = totalRecords + 1;
                    if (pageIndex == 1) {
                        // sortedIdArrayCopy.pop();
                        sortedIdArrayCopy.unshift(insertId);

                        if (statusListCopy[insertId] == undefined) {
                            statusListCopy[insertId] = {}
                        }

                        statusListCopy[insertId]['unique_id'] = insertId;
                        statusListCopy[insertId]['status'] = insertedStatus;
                        statusListCopy[insertId]['isIssueAccess'] = selectedAccess;
                        statusListCopy[insertId]['addedByName'] = config.instructorInfo.FirstName + " " + config.instructorInfo.LastName;
                        statusListCopy[insertId]['addedOn'] = currentDate;
                        statusListCopy[insertId]['isDefault'] = 'no';

                    }
                    setStatusList(statusListCopy);
                    setSortedIdArray(sortedIdArrayCopy);
                    setTotalRecords(totalRecordsCopy);
                    setSuccessModal(true);
                    setSuccessModalType('success');
                    setSuccessMessage(apiResult.message);
                }
                else {
                    setSuccessModal(true);
                    setSuccessModalType('warning');
                    setSuccessMessage(apiResult.message);
                }
                setAddStatusData(true);
                setLoadingAddOperation(false);
                setInsertedStatus('');
                setSelectedAccess('yes');

            } else {
                setAddStatusData(true);
                setLoadingAddOperation(false);
                setInsertedStatus('');
                setSelectedAccess('yes');
                setSuccessModal(true);
                setSuccessModalType('error');
                setSuccessMessage('Something went wrong while adding status data. Please try again later.');
            }
        }
    }

    const apiCallToUpdateStatus = async (status, access, uniqueid) => {

        const editAccess = props.isAdmin == true ? true : props.accessibleOperations['setting'].find(access => access === 'edit');

        if(editAccess !== undefined){

            setLoadingUpdateOperation(true);
    
            let requestData = {
                "iid": config.institute_id,
                "unique_id": uniqueid,
                "status": status,
                "facultyId": config.faculty_id,
                "isIssueAccess": access
            };
            let jsonResponse = await LibraryApiCall.makeApiCall(
                'updateLibraryResourceStatus',
                requestData,
                apiPath
            );
            if (jsonResponse.expired) {
                setTimeout(() => {
                    apiCallToUpdateStatus();
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult
    
                    if (apiResult.status == "success") {
                        let updatedId = jsonResponse.APIResult.uniqueId;
                        let currentDate = jsonResponse.APIResult.currentDate;
                        let statusListCopy = statusList;
    
                        statusListCopy[updatedId] = {
                            ...statusListCopy[updatedId],
                            'status': requestData['status'],
                            'isIssueAccess': requestData['isIssueAccess'],
                            ['updatedByName']: config.instructorInfo.FirstName + " " + config.instructorInfo.LastName,
                            ['updatedOn']: currentDate,
                        }
    
                        setIsEditable(null);
                        setUpdatedAccess('');
                        setUpdatedStatus('');
                        setSuccessModal(true);
                        setStatusList(statusListCopy);
                        setSuccessModalType('success');
                        setSuccessMessage(apiResult.message);
                    } else {
                        setSuccessModal(true);
                        setUpdatedAccess('');
                        setUpdatedStatus('');
                        setIsEditable(null);
                        setSuccessModalType('warning');
                        setSuccessMessage(apiResult.message);
                    }
                    setAddStatusData(true);
                    setLoadingUpdateOperation(false);
                    setIsEditable(null);
                    setUpdatedAccess('');
                    setUpdatedStatus('');
                    setSelectedAccess('yes');
    
                } else {
                    setAddStatusData(true);
                    setLoadingAddOperation(false);
                    setIsEditable(null);
                    setUpdatedAccess('');
                    setUpdatedStatus('');
                    setSelectedAccess('yes');
                    setSuccessModal(true);
                    setSuccessModalType('error');
                    setSuccessMessage('Something went wrong while adding status data. Please try again later.');
                }
            }
        }
        else
        {
            setSuccessModal(true);
            setSuccessModalType('warning');
            setSuccessMessage('This operation is restricted by the Library admin.');
        }

    }


    const apiCallToDeleteStatus = async (idToDelete) => {
        setLoadingDeleteOperation(true);

        const requestData = {
            iid: config.institute_id,
            unique_id_array: selectedStatusId.length > 0 ? selectedStatusId : '',
            facultyId: config.faculty_id

        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'deleteLibraryResourceStatus',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToDeleteStatus(idToDelete);
            }, 1000);
        } else {
            closeDeleteModal();
            if (jsonResponse.success) {
                const apiResult = jsonResponse.APIResult;
                let updatedStatusList = statusList;
                let updatedSortedIdArray = sortedIdArray;
                let updatedTotalRecords = totalRecords;


                if (apiResult.status == 'success') {

                    if (limit == requestData.unique_id_array.length) {
                        setPageIndex(1);
                        setOffset(0);
                    } else {
                        requestData.unique_id_array.forEach(statusId => {
                            delete updatedStatusList[statusId];
                            let index = updatedSortedIdArray.indexOf(statusId);
                            if (index !== -1) {
                                updatedSortedIdArray.splice(index, 1);
                            }
                        });
                    }

                    updatedTotalRecords = updatedTotalRecords - requestData.unique_id_array.length;

                    setLoadingDeleteOperation(false);
                    setStatusList(updatedStatusList);
                    setSortedIdArray(updatedSortedIdArray);
                    setTotalRecords(updatedTotalRecords);
                    setSuccessModal(true);
                    setSuccessModalType('success');
                    setSuccessMessage(apiResult.message);
                } else {
                    setSuccessModal(true);
                    setSuccessModalType('warning');
                    setSuccessMessage(apiResult.message);
                    setLoadingDeleteOperation(false);
                }
            } else {
                setSuccessModal(true);
                setSuccessModalType('error');
                setSuccessMessage('Something went wrong while deleting status data. Please try again later.');
                setLoadingDeleteOperation(false);
            }
        }
    }


    const validateUpdate = () => {

        if (updatedStatus == '') {
            setSuccessModal(true);
            setSuccessModalType('warning');
            setSuccessMessage('Status field should not be empty.');
        } else {
            apiCallToUpdateStatus();
        }
    }

    const validateAdd = () => {
        if (insertedStatus == '') {
            setSuccessModal(true);
            setSuccessModalType('warning');
            setSuccessMessage('Status field should not be empty.');
        } else {
            apiCallToAddStatus();
        }
    }

    const checkAddAccess = () => {

        const addAccess = props.isAdmin == true ? true : props.accessibleOperations['setting'].find(access => access === 'add');

        if(addAccess !== undefined){
            setAddStatusData(false)
        }
        else
        {
            setSuccessModal(true);
            setSuccessModalType('warning');
            setSuccessMessage('This operation is restricted by the Library admin.');
        }
    }

    const checkDeleteAccess = () => {
        const deleteAccess = props.isAdmin == true ? true : props.accessibleOperations['setting'].find(access => access === 'delete');
        if(deleteAccess !== undefined){
            setDeleteModal(true);
        }
        else
        {
            setSuccessModal(true);
            setSuccessModalType('warning');
            setSuccessMessage('This operation is restricted by the Library admin.');
        }

    }

    //FUNCTION TO UPDATE ALL THE DRIVER LIST CHECKBOX SELECTION
    const updateAllCheckboxSelection = (e) => {

        let statusIdSet = new Set();

        if (e.target.checked) {
            Object.keys(statusList).map(statusId => {
                statusIdSet.add(parseInt(statusId));
            });
        }
        else {
            Object.keys(statusList).map(statusId => {
                statusIdSet.delete(statusId);
            });
        }
        setSelectedStatusIds(Array.from(statusIdSet));
    }

    //METHOD TO SET SELECTED DRIVERS
    const setStatus = (e, selectedId) => {
        let statusId = selectedStatusIds;

        if (e.target.checked) {
            statusId.push(parseInt(selectedId));
        }
        else {
            statusId = selectedStatusIds.filter(id => id !== parseInt(selectedId));
        }
        setSelectedStatusIds(statusId);
    }

    // METHOD TO UPDATE employee PAGINATION COUNT
    const updatePaginationCount = (pageNumber) => {
        let tempNumber = pageNumber;
        setPageIndex(tempNumber);
        setOffset((pageNumber - 1) * limit);
        apiCallToGetStatusList(pageNumber);
    }

    const editableRow = statusIdObject => {
        if (loadingUpdateOperation) {
            return (
                <td colSpan={7}><ButtonLoader /></td>
            )
        } else {
            return (
                <>
                    <td className="p-1 align-middle ">{selectedRowNumber}</td>
                    <td className="p-1 align-middle ">
                        <input
                            type="text"
                            value={updatedStatus}
                            onChange={(e) => setUpdatedStatus(e.target.value)}
                            className="inputBox form-control"
                            placeholder='Type here'
                        />
                    </td>
                    <td className="p-1 align-middle ">
                        <div>
                            <select className='status-dropdown form-control' value={updatedAccess} onChange={(e) => setUpdatedAccess(e.target.value)}>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>
                    </td>
                    <td className='p-2 align-middle '>{statusIdObject.addedByName != '' && statusIdObject.addedByName != undefined ? statusIdObject.addedByName + " on " + statusIdObject.addedOn : ""}</td>
                    <td className='p-2 align-middle '>{statusIdObject.updatedByName != '' && statusIdObject.updatedByName != undefined ? statusIdObject.updatedByName + " on " + statusIdObject.updatedOn : ""}</td>
                    <td className="p-1 align-middle ">
                        <div className="row actions-add">
                            <FontAwesomeIcon
                                icon={["fas", "check"]}
                                size="md"
                                color='green'
                                onClick={() => validateUpdate()}
                            />
                            <FontAwesomeIcon
                                icon={["fa", "times"]}
                                size="md"
                                color='red'
                                onClick={() => setIsEditable(null)}
                            />
                        </div>
                    </td>
                </>
            )
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    const closeSuccessModal = () => setSuccessModal(false);

    // CLOSE DELETE TEMPLATE MODAL
    const closeDeleteModal = () => setDeleteModal(false);

    // Functions
    const openActivitySlider = (id) => {
        setSelectedIid(id);
        setShowActivitySlider(true);
    };

    const closeActivitySlider = () => {
        setSelectedIid("");
        setShowActivitySlider(false);
    };

    return (
        <>
            <RoutingMenu activeScreen="resourceStatus" />
            <div className="libraryComponents-container">
                <div>
                    <div className="pl-0 row col-md-12">

                        <button className="btn closeDetails" title="Click to visit back to library settings" style={{ marginRight: '10px' }} onClick={() => props.closeResourceStatus()} >
                            <FontAwesomeIcon className="" icon={["fa", "angle-left"]} />
                        </button>
                     &nbsp;
                        <div className="mt-1">
                            <h3>Add Book Status</h3>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <div className=" pl-0 col-md-12">
                            <div className='fixTableHead table-responsive customScrollDiv'>
                                <table className="table p-4 table-outline">
                                    <thead>
                                        <tr>
                                            {/* <th className="align-middle "><input
                                                type="checkbox"
                                                checked={
                                                    Object.keys(statusList).length >
                                                    0 &&
                                                    Object.keys(statusList).length == selectedStatusIds.length
                                                }
                                                onClick={(e) => updateAllCheckboxSelection(e)}
                                            />
                                            </th> */}
                                            <th className="align-middle ">Sr. No.</th>
                                            <th className="align-middle ">Resource Status</th>
                                            <th className="align-middle ">Issue Access &nbsp;<FontAwesomeIcon className="info-icon" title="Issue access, if selected as 'NO', the resources with the respective status will not be available for issue/return." icon={["fa", "info-circle"]} /></th>
                                            <th className="align-middle ">Added by</th>
                                            <th className="align-middle ">Modified by</th>
                                            <th className="align-middle "></th>
                                            <th className="align-middle ">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            loadingAddOperation ?
                                                <tr>
                                                    <td colSpan={7} className="addStatusDiv p-3">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr>
                                                :
                                                addStatusData ?
                                                    <tr>
                                                        <td colSpan={7} className="addStatusDiv p-2">
                                                            <label className='addLabel ml-4' onClick={() => checkAddAccess()}>+ Add new status</label>
                                                        </td>
                                                    </tr>
                                                    :
                                                    <tr >
                                                        <td colSpan={2} className="p-1 align-middle ">
                                                            <input
                                                                type="text"
                                                                value={insertedStatus}
                                                                onChange={(e) => setInsertedStatus(e.target.value)}
                                                                className="inputBox form-control"
                                                                placeholder='Type here'
                                                            />
                                                        </td>
                                                        <td className="p-1 align-middle ">
                                                            <div>
                                                                <select className='status-dropdown form-control' value={selectedAccess} onChange={(e) => setSelectedAccess(e.target.value)}>
                                                                    <option value="yes">Yes</option>
                                                                    <option value="no">No</option>
                                                                </select>
                                                            </div>
                                                        </td>
                                                        <td className="p-1 align-middle "></td>
                                                        <td className="p-1 align-middle "></td>
                                                        <td className="p-1 align-middle ">
                                                            <div className="row actions-add">
                                                                <FontAwesomeIcon
                                                                    icon={["fas", "check"]}
                                                                    size="md"
                                                                    color='green'
                                                                    onClick={() => validateAdd()}
                                                                />
                                                                <FontAwesomeIcon
                                                                    icon={["fa", "times"]}
                                                                    size="md"
                                                                    color='red'
                                                                    onClick={() => setAddStatusData(true)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                        }
                                        {loadingStatus ?
                                            <div className=" d-flex justify-content-center align-items-center">
                                                <ButtonLoader />
                                            </div>
                                            :
                                            Object.keys(statusList).length > 0 &&
                                            Object.keys(statusList).reverse().map((items, index) => {
                                                let statusData = statusList[items]
                                                if (statusData != undefined) {
                                                    let statusIdObject = statusList[items];
                                                    let selectedRowIndex = offset + index + 1;
                                                    return (
                                                        <tr key={statusIdObject.unique_id} className="p-2 " onMouseEnter={(e) => setHoverId(statusIdObject.unique_id)}>
                                                            {
                                                                isEditable == statusIdObject
                                                                    ?
                                                                    editableRow(statusIdObject)
                                                                    :
                                                                    <>
                                                                        <td className=' align-middle '>{offset + index + 1}</td>
                                                                        <td className='p-2 align-middle '>{statusIdObject.status}</td>
                                                                        <td className='p-2 align-middle '>
                                                                            <div>
                                                                                <select className='status-dropdown form-control' value={statusIdObject.isIssueAccess} disabled={statusIdObject.isDefault == 'yes' ? true : ''} onChange={(e) => {
                                                                                    apiCallToUpdateStatus(statusIdObject.status, e.target.value, statusIdObject.unique_id);
                                                                                    setUpdatedAccess(e.target.value);
                                                                                    setUniqueId(statusIdObject.unique_id);
                                                                                }
                                                                                }>
                                                                                    <option value="yes">Yes</option>
                                                                                    <option value="no">No</option>
                                                                                </select>
                                                                            </div>
                                                                        </td>
                                                                        <td className='p-2 align-middle '>{statusIdObject.addedByName != '' && statusIdObject.addedByName != undefined ? statusIdObject.addedByName + " on " + statusIdObject.addedOn : ""}</td>
                                                                        <td className='p-2 align-middle ' style={{ border: '1.01px solid #E0E8EF', padding: "5px", cursor: "pointer", color: statusIdObject.unique_id == hoverID ? "#0465AC" : "" }}
                                                                            onMouseEnter={() => setHoverID(statusIdObject.unique_id)}
                                                                            onMouseLeave={() => setHoverID("")}
                                                                            onClick={() => openActivitySlider(statusIdObject.unique_id)}>
                                                                            {statusIdObject.updatedByName != '' && statusIdObject.updatedByName != undefined ? statusIdObject.updatedByName + " on " + statusIdObject.updatedOn : ""}</td>
                                                                        <td><span className={statusIdObject.isDefault == 'yes' ? 'badge rounded-pill default ' : 'badge rounded-pill bg-success'} style={{ fontSize: 12 }}>{statusIdObject.isDefault == 'yes' ? 'Default' : 'Custom'}</span></td>
                                                                        <td className='p-2 align-middle '>
                                                                            <div className={hoverId == statusIdObject.unique_id ? "actions" : "actions hover"}>
                                                                                {/* <FontAwesomeIcon
                                                                                    icon={["fas", "pencil-alt"]}
                                                                                    size="md"
                                                                                    onClick={() => {
                                                                                        setUniqueId(statusIdObject.unique_id);
                                                                                        setDefaultInputValue(statusIdObject.status);
                                                                                        setExistingAccess(statusIdObject.isIssueAccess);
                                                                                        setSelectedRowNumber(selectedRowIndex);
                                                                                        setIsEditable(statusIdObject);
                                                                                    }}
                                                                                    color="blue"
                                                                                /> */}

                                                                                <div style={{ 'visibility': statusIdObject.isDefault == 'no' ? 'visible' : 'hidden' }}>
                                                                                    <FontAwesomeIcon
                                                                                        icon={["fas", "trash-alt"]}
                                                                                        size="md"
                                                                                        onClick={() => {
                                                                                            // setIdToDelete(statusIdObject.unique_id);
                                                                                            setSelectedStatusId([statusIdObject.unique_id])
                                                                                            checkDeleteAccess()
                                                                                        }}
                                                                                        color="blue"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </>
                                                            }
                                                        </tr>
                                                    );
                                                }
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {/* {
                                Object.keys(statusList).length > 0 &&
                                <div className="hidePrint mt-2">
                                    <Pagination
                                        activePage={pageIndex}
                                        itemsCountPerPage={limit}
                                        totalItemsCount={totalRecords}
                                        pageRangeDisplayed={3}
                                        onChange={(pageNumber) => {
                                            updatePaginationCount(pageNumber);
                                        }}
                                    />
                                </div>
                            } */}
                        </div>
                    </div>
                </div>
                {
                    successModal && successModalType != 'information' ?
                        <SuccessModal
                            successModal={successModal}
                            successModalType={successModalType}
                            successMessage={successMessage}
                            closeSuccessModal={closeSuccessModal}
                        />
                        :
                        <InformationModal
                            successModal={successModal}
                            successModalType={successModalType}
                            successMessage={successMessage}
                            closeSuccessModal={closeSuccessModal}
                        />
                }
                {
                    deleteModal &&
                    <DeleteModal
                        showModal={setDeleteModal}
                        visibility={closeDeleteModal}
                        deleteKey='Resource Status'
                        deleteComponent={apiCallToDeleteStatus}
                    />
                }
                {/* <ToastContainer /> */}
                {
                    showActivitySlider && selectedIid != "" &&
                    <SpecificUserLog
                        showSlider={showActivitySlider}
                        closeSlider={closeActivitySlider}
                        logUid={selectedIid}
                        activityArr={['resourceStatus_added','Status_updated']}
                    />
                }
            </div>
        </>
    )
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations:store.RouteMenuReducer.accessibleOperations,
        isAdmin:store.RouteMenuReducer.isLibraryAdmin
    };
};

export default connect(mapStateToProps)(ResourceStatus);
